import type { ReactNode } from "react";
import { styled } from "@pigment-css/react";
import { glassCapsulePress } from "@acto/taskpane/field-sales-2/styles/glassCapsulePress";

const CircleRoot = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "0 0 auto",
  width: theme.fieldSalesTwo.spacing[72],
  height: theme.fieldSalesTwo.spacing[72],
  borderRadius: theme.fieldSalesTwo.radius.circular,
  border: `1.25px solid ${theme.fieldSalesTwo.colors.surface.glassBorderStrong}`,
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  backdropFilter: "blur(2px)",
  WebkitBackdropFilter: "blur(2px)",
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  color: theme.fieldSalesTwo.colors.neutral[900],
  cursor: "pointer",
  padding: 0,
  ...glassCapsulePress(theme, { restShadow: theme.fieldSalesTwo.shadows.glass }),
}));

interface BottomNavCircleButtonProps {
  icon: ReactNode;
  onClick?: () => void;
  "aria-label": string;
}

export function BottomNavCircleButton({ icon, onClick, "aria-label": ariaLabel }: BottomNavCircleButtonProps) {
  return (
    <CircleRoot type="button" onClick={onClick} aria-label={ariaLabel}>
      {icon}
    </CircleRoot>
  );
}
